import { Reveal } from "@/components/Reveal";
import { Check } from "lucide-react";

const tiers = [
  {
    name: "The Social",
    price: "$650",
    unit: "up to 40 guests",
    features: ["2 signature cocktails", "3 hours of service", "1 bartender", "Bar setup + glassware", "Zero-proof options"],
    featured: false,
  },
  {
    name: "The Signature",
    price: "$1,200",
    unit: "up to 100 guests",
    features: ["4 custom cocktails", "5 hours of service", "2 bartenders", "Premium spirits + garnishes", "Live flair station", "Custom menu design"],
    featured: true,
  },
  {
    name: "The Grand",
    price: "Custom",
    unit: "150+ guests",
    features: ["Unlimited menu design", "Full-day service", "Dedicated team", "Smoke & tableside theatre", "Bespoke bar build", "On-site consultation"],
    featured: false,
  },
];

export default function Packages() {
  return (
    <section id="packages" className="py-24 md:py-32 px-6 md:px-12" data-testid="packages-section">
      <div className="max-w-7xl mx-auto">
        <Reveal className="mb-16 text-center max-w-2xl mx-auto">
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-5">Packages</p>
          <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl tracking-tight leading-none">
            Priced for the <span className="italic gold-shimmer">occasion.</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {tiers.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <div
                data-testid={`package-card-${i}`}
                className={`relative h-full flex flex-col p-8 md:p-10 border transition-all duration-500 hover:-translate-y-2 ${
                  t.featured
                    ? "bg-gradient-to-b from-[#141007] to-[#0a0a0a] border-gold/60"
                    : "bg-[#0a0a0a] border-[#222] hover:border-gold/40"
                }`}
              >
                {t.featured && (
                  <span className="absolute -top-3 left-8 bg-gold text-black text-[10px] uppercase tracking-[0.2em] px-3 py-1">
                    Most Booked
                  </span>
                )}
                <h3 className="font-heading text-3xl mb-1">{t.name}</h3>
                <p className="text-[#a0a0a0] text-xs uppercase tracking-[0.2em] mb-6">{t.unit}</p>
                <div className="flex items-end gap-2 mb-8">
                  <span className="font-heading text-5xl text-gold">{t.price}</span>
                  {t.price !== "Custom" && <span className="text-[#a0a0a0] text-sm mb-2">/ event</span>}
                </div>
                <ul className="flex flex-col gap-3 mb-10 flex-1">
                  {t.features.map((f) => (
                    <li key={f} className="flex items-start gap-3 text-sm text-white/85 font-light">
                      <Check size={16} className="text-gold mt-0.5 shrink-0" />
                      {f}
                    </li>
                  ))}
                </ul>
                <a
                  href="#booking"
                  data-testid={`package-cta-${i}`}
                  className={`text-center py-3.5 text-xs uppercase tracking-[0.25em] transition-all duration-300 active:scale-[0.98] ${
                    t.featured
                      ? "bg-gold text-black hover:bg-[#e5c158]"
                      : "border border-gold/50 text-gold hover:bg-gold hover:text-black"
                  }`}
                >
                  Book This
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
